import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Webdevelopment from "../HomePage/WebDevelopment/Webdevelopment";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import Ourservicebanner from "./Ourservicebanner";
import Ourservicespacing from "./Ourservicespacing";
import ScrollToTopButton from "../HomePage/Scrolltotop/ScrollToTopButton";
import { useEffect } from "react";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";
import { Helmet } from "react-helmet-async";

function Ourservicessection() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top when the component mounts
  }, []);

  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>Our Services | Full-Stack Web, Mobile & AI Solutions - Dwebbox</title>
        <meta
          name="description"
          content="Explore Dwebbox's range of digital services including MERN stack development, React Native mobile apps, AI & ML solutions, UI/UX design, and SEO optimization."
        />
        <meta name="keywords" content="software services, custom web development, mobile app agency, AI development India, UI/UX design services" />
        <link rel="canonical" href="https://dwebbox.com/ourservice" />
        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://dwebbox.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Services",
                "item": "https://dwebbox.com/ourservice"
              }
            ]
          })}
        </script>
      </Helmet>
      <ScrollToTopButton />
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <Ourservicebanner />
      <Webdevelopment />
      <Ourservicespacing />
      <Bgimage />
      <Footer />
    </div>
  );
}

export default Ourservicessection;
